export default "__VITE_ASSET__9b43fcee__"